import _ from 'underscore';
import { constants } from '@bingads-webui-campaign-react/image-experience';

export const getImagesFromImageList = imageList => (
  _.map(imageList, imageObj => (
    {
      Id: '',
      Asset: {
        '@odata.type': '#Model.ImageAsset',
        Id: imageObj.Id,
        IdString: imageObj.IdString,
        SubType: constants.aspectRatios[imageObj.Type].associationType,
        CropX: imageObj.CropSettings.SourceX,
        CropY: imageObj.CropSettings.SourceY,
        CropHeight: imageObj.CropSettings.SourceHeight,
        CropWidth: imageObj.CropSettings.SourceWidth,
        ImageUrl: imageObj.Src,
      },
    }
  ))
);

export const createImageExtensionMtModel = (fieldValues, imageList) => ({
  AltText: fieldValues.AltText,
  DisplayText: fieldValues.DisplayText,
  EligibleLayout: 'Single',
  Images: getImagesFromImageList(imageList),
  Scheduling: {},
});

// if Id exists, means item is an existing association
export const isImageExtensionCommitedToServer = item => !!item.Id;

export const extractImageExtensionCreationMtFields = model => _.pick(model, [
  'AltText',
  'DisplayText',
  'EligibleLayout',
  'Images',
  'Scheduling',
]);
